/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Personal_LinkInputs */

const cs_integrations_personal_link = /** @type {(inputs: Integrations_Personal_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít můj profil`)
};

const en_integrations_personal_link = /** @type {(inputs: Integrations_Personal_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open my profile`)
};

/**
* | output |
* | --- |
* | "Open my profile" |
*
* @param {Integrations_Personal_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_personal_link = /** @type {((inputs?: Integrations_Personal_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Personal_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_personal_link(inputs)
	return cs_integrations_personal_link(inputs)
});